import cx from 'classnames';
import * as React from 'react';
import MessageReaction from 'chat/components/MessageReaction';
import ReactionButton from 'chat/components/ReactionButton';
import ReactionPickerTrigger from 'chat/components/ReactionPickerTrigger';
import type { ReactionSummaryFragment } from './Reaction/__generated__/ReactionSummaryFragment';

import './styles/ReactionDisplay.scss';

type Props = {
  sentBySelf?: boolean;
  disableReactionToggle?: boolean;
  addReactionToSummary: (name: string) => void;
  removeReactionFromSummary: (name: string) => void;
  reactionSummary: ReactionSummaryFragment | undefined | null;
};

export default function ReactionDisplay(props: Props) {
  const { reactionSummary, sentBySelf } = props;
  const reactions = reactionSummary?.reactions || [];

  if (!reactions.length) {
    return null;
  }

  return (
    <div
      className={cx('ReactionDisplay', {
        'ReactionDisplay-self': sentBySelf,
        'ReactionDisplay-other': !sentBySelf,
      })}
    >
      {reactions.map((reaction) => (
        <MessageReaction
          key={reaction.name}
          reaction={reaction}
          disableReactionToggle={!!props.disableReactionToggle}
          addReactionToSummary={props.addReactionToSummary}
          removeReactionFromSummary={props.removeReactionFromSummary}
        />
      ))}
      {!props.disableReactionToggle && (
        <ReactionPickerTrigger
          // @ts-expect-error
          className="ReactionDisplay-addButton"
          alignment={sentBySelf ? 'right' : 'left'}
          addReactionToSummary={props.addReactionToSummary}
          removeReactionFromSummary={props.removeReactionFromSummary}
        >
          <ReactionButton includeBorder />
        </ReactionPickerTrigger>
      )}
    </div>
  );
}
